/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import Popover from 'DesignSystem/Popover/index'
import React from 'react'
import TysiaDatePicker from 'DesignSystem/TysiaDatePicker/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/BulkActions/Content/DueDateAction/Content",
  value
  
}) {
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  value
  
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaDatePicker
  viewPath={`${viewPath}/TysiaDatePicker`}
 value={value}
 onChange={onChange}
/>
</div>
)}
</Popover>
{children}
</React.Fragment>)
}